import { apiSlice } from './apiSlice';

const ASSIGNMENTS_URL = '/api/assignments';

export const assignmentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get assignment status for a league
    getAssignmentStatus: builder.query({
      query: (leagueId) => ({
        url: `${ASSIGNMENTS_URL}/status/${leagueId}`,
        method: 'GET',
        credentials: 'include',
      }),
      providesTags: ['Assignment', 'League', 'Team', 'Athlete'],
    }),
    
    // Calculate salary cap for an athlete
    calculateAthleteSalary: builder.query({
      query: (athleteId) => ({
        url: `${ASSIGNMENTS_URL}/calculate-salary/${athleteId}`,
        method: 'GET',
        credentials: 'include',
      }),
      providesTags: ['Assignment'],
    }),
    
    // Set manual salary for athlete
    setAthleteSalary: builder.mutation({
      query: ({ athleteId, salary, leagueId }) => ({
        url: `${ASSIGNMENTS_URL}/set-salary/${athleteId}`,
        method: 'PUT',
        body: { salary, leagueId },
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Athlete', 'Team'],
    }),

    setAthleteExpectedDistance: builder.mutation({
      query: ({ athleteId, expectedWeeklyDistance, leagueId }) => ({
        url: `${ASSIGNMENTS_URL}/set-expected-distance/${athleteId}`,
        method: 'PUT',
        body: { expectedWeeklyDistance, leagueId },
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Athlete', 'Team'],
    }),

    generateRankedSalaries: builder.mutation({
      query: ({ leagueId, rankings }) => ({
        url: `${ASSIGNMENTS_URL}/generate-ranked-salaries/${leagueId}`,
        method: 'POST',
        body: { rankings },
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Athlete', 'Team'],
    }),

    generateNewSeasonSalaries: builder.mutation({
      query: ({ leagueId, rankings }) => ({
        url: `${ASSIGNMENTS_URL}/generate-ranked-salaries/${leagueId}`,
        method: 'POST',
        body: rankings ? { rankings } : {},
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Athlete', 'Team', 'League'],
    }),
    
    // Auto-assign athletes to teams
    autoAssignAthletes: builder.mutation({
      query: (leagueId) => ({
        url: `${ASSIGNMENTS_URL}/auto-assign/${leagueId}`,
        method: 'POST',
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'League', 'Team', 'Athlete'],
    }),
    
    // Manually assign athlete to team
    manualAssignAthlete: builder.mutation({
      query: ({ athleteId, teamId, salary }) => ({
        url: `${ASSIGNMENTS_URL}/manual-assign`,
        method: 'POST',
        body: { athleteId, teamId, salary },
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Team', 'Athlete'],
    }),

    manualUnassignAthlete: builder.mutation({
      query: ({ athleteId, teamId }) => ({
        url: `${ASSIGNMENTS_URL}/manual-assign/${athleteId}`,
        method: 'DELETE',
        body: { teamId },
        credentials: 'include',
      }),
      invalidatesTags: ['Assignment', 'Team', 'Athlete'],
    }),
  }),
});

export const {
  useGetAssignmentStatusQuery,
  useCalculateAthleteSalaryQuery,
  useSetAthleteSalaryMutation,
  useSetAthleteExpectedDistanceMutation,
  useGenerateRankedSalariesMutation,
  useGenerateNewSeasonSalariesMutation,
  useAutoAssignAthletesMutation,
  useManualAssignAthleteMutation,
  useManualUnassignAthleteMutation,
} = assignmentsApiSlice;
